import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import thunk from 'redux-thunk'
import * as reducers from './reducers';

const middleWare = [thunk];

if (process.env.NODE_ENV !== 'production') {
    const { logger } = require('redux-logger');
    middleWare.push(logger);
}

const enhancer = compose(
    applyMiddleware(
        ...middleWare,
    ),
);

const rootReducer = combineReducers({
    ...reducers.default,
});

const initialState = {};

const store = createStore(
    rootReducer,
    initialState,
    enhancer
);

export default store;